function getTimestampOrUndefined(timestamp) {
    if (!timestamp) {
        return undefined;
    }
    const value = new Date(timestamp).getTime();
    return Number.isFinite(value) ? value : undefined;
}
export function getExecutionDisplayTimestamp(execution) {
    return execution.started_at;
}
export function formatExecutionDateTime(timestamp) {
    const parsedTimestamp = getTimestampOrUndefined(timestamp);
    return parsedTimestamp !== undefined ? new Date(parsedTimestamp).toLocaleString('ja-JP') : '-';
}
export function formatExecutionDuration(execution, now = Date.now()) {
    if (typeof execution.duration_ms === 'number') {
        return execution.duration_ms < 1000
            ? `${execution.duration_ms}ms`
            : `${Math.round(execution.duration_ms / 1000)}秒`;
    }
    if (execution.status === 'running' && execution.started_at) {
        const startedAt = getTimestampOrUndefined(execution.started_at);
        if (startedAt !== undefined) {
            return `${Math.round((now - startedAt) / 1000)}秒`;
        }
    }
    return '-';
}
